<template>
  <v-dialog v-model="show" max-width="400" persistent @update:model-value="handleDialogClose">
    <v-card>
      <v-card-title>
        {{ isEdit ? 'Rename Folder' : 'Create Folder' }}
      </v-card-title>

      <v-card-text>
        <v-text-field
          ref="folderNameInput"
          v-model="form.name"
          label="Folder Name"
        />
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn variant="text" @click="closeDialog">Cancel</v-btn>
        <v-btn color="primary" @click="submit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'
import axios from 'axios';
import { prefix } from '@/store/api';

const props = defineProps({
  modelValue: Boolean,
  folder: Object,
  parentId: Number,
})

const emit = defineEmits(['update:modelValue', 'saved'])

const show = ref(false)
const isEdit = ref(false)
const form = ref({ name: '' })
const folderNameInput = ref(null)

watch(() => props.modelValue, async v => {
  show.value = v
  if (v) {
    if (props.folder) {
      isEdit.value = true
      form.value.name = props.folder.name
    } else {
      isEdit.value = false
      form.value.name = ''
    }
    // Focus the input after dialog opens
    await nextTick()
    folderNameInput.value?.focus()
  }
})

const handleDialogClose = (value) => {
  if (!value) {
    emit('update:modelValue', false)
  }
}

const closeDialog = () => {
  show.value = false
}

const submit = async () => {
  if (isEdit.value) {
    await axios.put(`${prefix}cms/folders/${props.folder.id}`, form.value)
  } else {
    await axios.post(`${prefix}cms/folders`, {
      name: form.value.name,
      parent_id: props.parentId,
    })
  }

  emit('saved')
  emit('update:modelValue', false)
}
</script>
